import type { IconData } from '@stacksjs/iconify-core'

export const glassFilledF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 18v-6.07A7.002 7.002 0 0 1 2.101 0h9.798A7.002 7.002 0 0 1 8 11.93V18h2a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zM2 5h10q-.357-2.145-1-3H3q-.643.855-1 3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default glassFilledF
